import classNames from 'classnames';
import React from 'react';
// TODO: MOVE TO ATOMS
const ProgressBar: React.FC<{
  stepsNumber?: number;
  step: number;
  className?: string;
}> = ({ step, stepsNumber = 2, className }) => {
  const stepsArray = Array.from({ length: stepsNumber }, (_, i) => i + 1);

  return (
    <div className={classNames('flex gap-8', className)}>
      {stepsArray.map((cur) => (
        <div
          key={`step${cur}`}
          className={classNames(
            'h-2 w-full rounded-lg',
            step >= 1 && step >= cur
              ? 'bg-secondary-20'
              : 'bg-neutralVariant-95'
          )}
        />
      ))}
    </div>
  );
};

export default ProgressBar;
